import React from "react";
import { Checkbox, Empty, Space } from "antd";
import { SupplierTypeGroup, SUPPLIER_TYPE_LABELS } from "../../../types/BuyerBriefTypes";
import { CONDITIONAL_TOPICS } from "../topicConfig";

interface Props {
    supplierType?: SupplierTypeGroup;
    selectedTopics: string[];
    onChange: (topics: string[]) => void;
}

const ConditionalTopicStep: React.FC<Props> = ({ supplierType, selectedTopics, onChange }) => {
    const topics = supplierType ? CONDITIONAL_TOPICS[supplierType] || [] : [];
    const typeLabel = supplierType ? SUPPLIER_TYPE_LABELS[supplierType] : "";

    const handleToggle = (topicId: string) => {
        if (selectedTopics.includes(topicId)) {
            onChange(selectedTopics.filter((t) => t !== topicId));
        } else {
            onChange([...selectedTopics, topicId]);
        }
    };

    if (topics.length === 0) {
        return (
            <div>
                <h3>Supplier-Specific Topics</h3>
                <Empty description="No additional topics available for this supplier type. You can proceed to the next step." />
            </div>
        );
    }

    return (
        <div>
            <h3>{typeLabel} - Specific Research Topics</h3>
            <p style={{ marginBottom: 16, opacity: 0.7 }}>
                Select additional topics specific to {typeLabel} suppliers.
            </p>
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
                {topics.map((topic) => (
                    <Checkbox
                        key={topic.id}
                        checked={selectedTopics.includes(topic.id)}
                        onChange={() => handleToggle(topic.id)}
                    >
                        <strong>{topic.label}</strong>
                        <br />
                        <span style={{ opacity: 0.7, fontSize: 12 }}>{topic.description}</span>
                    </Checkbox>
                ))}
            </Space>
        </div>
    );
};

export default ConditionalTopicStep;
